(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/footer/footer.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/footer/footer.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_login.atoms;
const {
  loginMethods
} = svs.iam_login.constants;
const {
  ToggleCustomer,
  GetApp
} = svs.iam_login.components.footer;
const Footer = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return React.createElement("footer", {
    className: "footer"
  }, activeMethod === loginMethods.freja && React.createElement(ToggleCustomer, null), React.createElement(GetApp, null));
};
svs.iam_login.components.footer.Footer = Footer;

 })(window);